const DEFAULT_VISIBLE_POINTS = 20;
const DENSE_CHART_THRESHOLD = 15;
const CHART_DATA_ZOOM_SLIDER_BOTTOM = 32;

/** Espaço inferior do grid com dataZoom + legenda ECharts na parte de baixo */
export const CHART_GRID_BOTTOM = 132;

/** Espaço inferior do grid com dataZoom e sem legenda */
export const CHART_GRID_BOTTOM_ZOOM_ONLY = 80;

export function shouldShowSeriesLabels(pointCount: number): boolean {
  return pointCount <= DENSE_CHART_THRESHOLD;
}

export function getInitialZoomStart(pointCount: number, visiblePoints = DEFAULT_VISIBLE_POINTS): number {
  if (pointCount <= visiblePoints) {
    return 0;
  }

  return Math.max(0, ((pointCount - visiblePoints) / pointCount) * 100);
}

export function buildXAxisDataZoom(
  pointCount: number,
  visiblePoints = DEFAULT_VISIBLE_POINTS
): Record<string, unknown>[] {
  const start = getInitialZoomStart(pointCount, visiblePoints);

  return [
    {
      type: 'inside',
      xAxisIndex: 0,
      start,
      end: 100,
      zoomOnMouseWheel: true,
      moveOnMouseWheel: false,
      moveOnMouseMove: true,
    },
    {
      type: 'slider',
      xAxisIndex: 0,
      start,
      end: 100,
      height: 18,
      bottom: CHART_DATA_ZOOM_SLIDER_BOTTOM,
      borderColor: '#E0E2E5',
      fillerColor: 'rgba(41, 83, 166, 0.12)',
      handleStyle: { color: '#2953A6' },
      textStyle: { color: '#575C66', fontSize: 10 },
    },
  ];
}
